/** English text for the compare page, quiz, product pages and status page. Each value is also its translation key. */
export const P = {
  home: 'Home',
  vs: 'vs',
  compareIntro:
    'Wraith brings the biggest selection and North American sports. Demon brings higher quality sports, more European content and up to five screens at once.',
  notOnSale: "These plans aren't on sale right now.",
  back: 'Back to Ghost Cable',
  pickIf: 'Pick {name} if',
  wMost: 'You want the most shows and channels',
  wNA: 'You mostly watch North American sports and content',
  wOne: 'You watch on one screen at a time',
  wEpg: 'You want the premium EPG (6 or 12 month packages)',
  dSports: 'You want higher quality sports',
  dEU: 'You mostly watch European content',
  dMulti: 'Two to five people watch at the same time',
  dLong: 'You want to lock in a long term, up to 3 years',
  notSure: 'Not sure yet?',
  readFaq: 'Read the FAQ',
  or: 'or',
  messageUs: 'message us',

  q1: 'Do you want the biggest selection, with as many shows and channels as possible?',
  q2: 'Is higher quality sports important to you?',
  q3: 'Will more than one screen be watching at the same time?',
  q4: 'Are you mostly after European content?',
  q5: 'Are you mostly after North American sports and content?',
  rMulti: 'You need more than one screen at a time',
  rEU: 'You want more European content',
  rNA: 'You want more North American sports and content',
  yourMatch: 'Your match',
  lean: 'Some of your answers lean {other}, but {other} is one screen at a time, so {plan} is the plan that covers everyone watching.',
  seePrices: 'See {name} prices',
  bothFit: 'Both plans fit you.',
  split: "Your answers are split evenly between {a} and {b}. Compare the prices below, or message us and we'll help you pick.",
  comparePrices: 'Compare prices',
  msgUs: 'Message us',
  startOver: 'Start over',
  quizTitle: 'Not sure which one? Answer five questions.',
  qOf: 'Question {n} of {total}',
  yes: 'Yes',
  no: 'No',
  backBtn: 'Back',

  oneScreen: 'One screen',
  oneToFive: '1 to 5 screens',
  screensSame: 'Screens at the same time',
  oneOnly: '{name} is one screen only.',
  fromPerMonth: 'From {price}/mo for one screen',
  notOffered: 'Not offered',
  oneScreenOnly: 'One screen only',
  pkg: 'Package',
  toRange: '{a} to {b}',
  bestW: 'The most shows and channels, and North American sports',
  bestD: 'Higher quality sports, European content and more than one screen',
  bestB: 'Invited customers on private pricing',
  bestFor: 'Best for',
  lengths: 'Package lengths',
  live: 'Live TV channels',
  vod: 'Movies and VOD',
  quality: 'Picture quality',
  epg: 'TV guide (EPG)',
  catchup: 'Catch-up TV',
  ppv: 'PPV events',
  who: 'Who can order',
  invite: 'Invitation only',
  anyone: 'Anyone',
  askUs: 'Ask us',
  qualityVal: '4K, FHD, HD and SD',
  epgW: 'Premium EPG with 6 and 12 month packages',
  epgD: 'Included on every package',
  whatYouGet: 'What you get',
  included: "What's included",
  pricesSide: 'Prices side by side',
  inUsd: 'In US dollars. Tap a price to order that package.',
  everyPlan: 'Every plan accepts',
  ready: 'Ready to order',
  changeAt: 'You can change the package at checkout.',
  screensN: '{count} screens',
  summonB: 'Summon the Banshee',

  nothing: 'Nothing on this channel',
  seePlans: 'See the plans',
  notHere: 'That product is not here.',
  oldLink: 'The link may be old or mistyped. Everything we sell is on the plans page.',
  unavailable: '{name} is not available right now.',
  paused: 'It is paused for the moment. Check back soon, or pick one of the plans below.',
  gcPlan: 'Ghost Cable plan',
  fromHouse: 'From the house',
  pricesOptions: 'Prices and options',
  pickOnPlans: 'Pick your screens and term on the plans page. Prices are in US dollars.',
  ctaDemon: 'Pick screens and term',
  ctaWraith: 'Pick a package',
  ctaTelly: 'Get Desktop Telly',
  seePricesBtn: 'See prices',
  pricing: 'Pricing',
  onWay: 'Prices for this one are on their way. Message us from the contact form and we will sort you out.',
  contactUs: 'Contact us',
  order: 'Order {name}',
  paidOnce: 'Paid once, no renewals.',
  noCharge: 'Nothing is charged here. After your order is taken, you get a payment link once it is reviewed.',
  oneTime: 'One-time',

  updated: 'Updated {time}',
  sUp: 'Operational',
  sMaint: 'Maintenance',
  sDeg: 'Having issues',
  sErr: 'Connection errors',
  sDown: 'Down',
  hUp: 'All systems operational',
  hMaint: 'Scheduled maintenance',
  hDeg: 'Some services are having issues',
  hDown: 'Service outage',
  bUp: 'Everything is streaming normally.',
  bMaint: "We're working on part of the service. It will be back shortly.",
  bDeg: 'You may notice buffering or slow loading. We are on it.',
  bErr: "Some connections are failing right now. We're working on a fix.",
  bDown: "Part of Ghost Cable is down. We're working to bring it back.",
  isThe: 'Is the {signal} alive?',
  signal: 'signal',
  stateIntro: 'The current state of every part of Ghost Cable. This page refreshes on its own every minute.',
  cantLoad: "We couldn't load the status right now.",
  noServices: 'No services listed yet',
  trouble: 'Having trouble watching?',
  sendMsg: 'Send us a message',
  stillTrouble: 'Still having trouble when everything shows operational?',
  contactSupport: 'Contact support',
};

/** Splits a translated sentence around one {placeholder}, so a styled value can sit inside it. */
export function around(text, name) {
  const i = text.indexOf(`{${name}}`);
  if (i < 0) return [text, ''];
  return [text.slice(0, i), text.slice(i + name.length + 2)];
}
